export function emailValidation(string) {
  const regex = new RegExp(/^(([^<>()[\]\\.,;:\s@\\"]+(\.[^<>()[\]\\.,;:\s@\\"]+)*)|(\\".+\\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
  return string && regex.test(string);
}

export function myNRICValidation(string) {
  const regex = new RegExp(/^([0-9][0-9])((0[1-9])|(1[0-2]))((0[1-9]|[1-2][0-9]|3[0-1]))([0-9][0-9])([0-9][0-9][0-9][0-9])$/);
  return string && regex.test(string);
}
